import { Suspense, lazy } from 'react';

const LazyRender = (loader) => {
	const LazyComponent = lazy(() =>
		loader().catch((error) => {
			console.error('Failed to load lazy component:', error);
			return {
				default: () => (
					<div style={{ padding: 16, color: '#b42318', background: '#fef3f2', border: '1px solid #fecdca', borderRadius: 6 }}>
						Unable to load static form component. Please verify import path and module export.
					</div>
				),
			};
		})
	);

	const LazyModalRenderer = (args) => (
		<Suspense fallback={null}>
			<LazyComponent {...args} />
		</Suspense>
	);

	LazyModalRenderer.displayName = 'LazyModalRenderer';

	return LazyModalRenderer;
};

export default LazyRender;
